<template>
    <div class="px-6 pb-2 pt-6">
        <!-- Кнопка вызова окна для создания умк -->
        <vs-button @click="openCreateModal(true)" class="w-full">{{$t('emc_create_button')}}</vs-button>

        <!-- Модалка с формой создания умк -->
        <vs-popup
        class="emc_popup"
        :title="$t('emc_create_button')"
        :active.sync="activePrompt">
            <form v-if="Object.keys(createdData).length" class="items-start w-full flex">
                <div class="w-1/2">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <multiselect
                                label="name"
                                v-model="disciplineSelect"
                                :options="createdData.disciplines"
                                selectedLabel="Выбрано"
                                :placeholder="$t('discipline')"
                                v-validate="'required'"
                                name="discipline"
                                deselectLabel=""
                                selectLabel=""
                                @select="multiselectAction"
                                track-by="uid">
                                    <template slot="singleLabel" slot-scope="props">{{ props.option.name }}</template>
                                    <template slot="option" slot-scope="props">{{ props.option.name }}</template>
                                    <div slot="noOptions">{{$t('no_data_text')}}</div>
                            </multiselect>
                            <span class="text-danger text-sm" v-show="errors.has('discipline')">{{ $t('validation_required') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" v-validate="'required'" name="title" :label="$t('title')" v-model="emc.name" />
                            <span class="text-danger text-sm" v-show="errors.has('title')">{{ $t('validation_required') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <vs-textarea class="mb-0" v-validate="'required'" name="description" :label="$t('description')" v-model="emc.description" />
                            <span class="text-danger text-sm" v-show="errors.has('description')">{{ $t('validation_required') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col">
                            <label for="" class="vs-input--label">{{$t('language')}}</label>
                            <v-select
                                v-validate="'required'"
                                style="width:200px;"
                                v-model="emc.language"
                                :getOptionLabel="getOptionLabel"
                                :reduce="lang => lang.uid"
                                :options="createdData.languages"
                                name="language"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                            <span class="text-danger text-sm" v-show="errors.has('language')">{{ $t('validation_required') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col">
                            <!-- Добавить умк -->
                            <vs-button color="primary" @click="formSubmit()" type="filled">{{ updated ? $t('edit') : $t('add')}}</vs-button>
                        </div>
                        <div class="vx-col">
                            <!-- Закрыть окно -->
                            <vs-button @click="closePopup()" color="dark" type="border">{{$t('close')}}</vs-button>
                        </div>
                    </div>
                </div>

                <div class="mx-4 flex-col w-2/3">
                    <div class="vx-row mb-6" v-if="Object.keys(uploadSettings).length">
                        <div class="vx-col w-full">
                            <div class="vx-row mb-2">
                                <div class="vx-col">
                                    <label for="files_input" class="files_input_button vs-component vs-button vs-button-primary vs-button-filled includeIcon">
                                        <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-upload null" style="order: 0; margin-right: 5px; margin-left: 0px;"></i>
                                        <span class="vs-button-text vs-button--text">{{$t('upload_file')}}</span>
                                    </label>
                                </div>
                                <EmcFileModal class="mt-1" :formFiles="emc.files_data" :fileSelectHandler="fileSelectHandler" />
                            </div>
                            <input type="file"  id="files_input" class="files_input" multiple ref="files" v-on:change="handleFileUpload()"/>

                            <!-- Список прикрепленных к умк файлов -->
                            <div class="file_item" v-for="(file, index) in emc.files_data" :key="`file_${index}`">
                                <div :title="$t('remove')" class="cursor-pointer delete_button bg-danger" @click="fileDelete(index)">
                                    <vs-icon icon="delete"></vs-icon>
                                </div>
                                <div class="file_name flex items-center mb-1">{{file.formName}}</div>
                                <div class="mb-1">
                                    <vs-input class="w-full" v-validate="'required'" :name="`filename${index}`" :label="$t('file_name')" v-model="emc.files_data[index].name" />
                                    <span class="text-danger text-sm" v-show="errors.has(`filename${index}`)">{{$t("validation_required")}}</span>
                                </div>
                                <div>
                                    <vs-textarea class="w-full file_desc" :name="`filedesc${index}`" :label="$t('file_description')" v-model="emc.files_data[index].description" />
                                    <span class="text-danger text-sm" v-show="errors.has(`filedesc${index}`)">{{ errors.first(`filedesc${index}`) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </vs-popup>
    </div>
</template>

<script>
import EmcFileModal from './EmcFileModal'
import vSelect from 'vue-select'
import { Validator } from "vee-validate";
import {eventBus} from '../../../main'

const messages = {
    custom: {
        discipline: {
            required: "Это обязательное поле",
        },
        title: {
            required: "Это обязательное поле",
        },
        description: {
            required: "Это обязательное поле",
        },
        language: {
            required: "Это обязательное поле",
        },
    },
};

Validator.localize("en", messages);

import { mapActions, mapMutations } from "vuex";
export default {
    props: {
        updatedData: [Array, Object]
    },
    data () {
        return {
            disciplineSelect: null,
            activePrompt: false,
            uploadDisabled: false,
            updated: false,
            emc: {
                name: '',
                discipline: null,
                description: '',
                language: null,
                files_data: [

                ]
            }
        }
    },
    components: {
        EmcFileModal,
        vSelect
    },
    computed: {
        createdData() {
            return this.$store.state.emc.createdData
        },
        uploadSettings() {
            // Получаем настройки формы
            return this.$store.state.emc.formSetting
        },
        languageText() {
            return `name_${ this.$i18n.locale }`
        }
    },
    created(){
        eventBus.$on('editEmc', (val) => {
            if(val){
                this.openCreateModal(true)
            }

        } )

        eventBus.$on('startEmc', (val) => {
            if(val){
                this.openCreateModal(false)
                setTimeout(() => {
                    this.activePrompt = false
                }, 370);
            }

        } )
    },
    watch: {
        activePrompt(val){
            if(!val){
                this.$emit('closed')
            }
        }
    },
    methods: {
        ...mapActions({
            fetchFormData: "emc/fetchFormData",
            addEmc: "emc/postEmc",
            updateEmc: "emc/update",

        }),
        ...mapMutations({
            updateThisEmc: "emc/UPDATE_EMC"
        }),
        getOptionLabel(item) {
            // Возвращаем лэйбл списка с учетом языка пользователя
            let name = item[`name_${ this.$i18n.locale }`]
            if(name)
                return  name[0].toUpperCase() + name.slice(1)
            else // Если ключ перевода пустой
                return 'Нет перевода'
        },
        fileSelectHandler(files) {
            // Функция передаеться в компонент EmcFileModal, для выбора ранее загруженного файла
            // Проверяем, существует ли файл с таким же именем, если существует выводим сообщение
            if(files.length) {
                files.forEach(file => {
                    if(this.emc.files_data.find(item => item.uid === file.uid)) {
                        this.$vs.notify({
                            text: `Файл ${ file.file.name } уже добавлен в список`,
                            color: 'warning'
                        })
                    } else {
                        this.emc.files_data.push({
                            ...file,
                            description: file.description,
                            name: file.name,
                            uid: file.file.uid,
                            formName: file.file.name,
                        })
                    }
                })
            }
        },
        async handleFileUpload() {
            // Получаем файлы от поля загрузки
            const files = this.$refs.files.files;


            let formData = new FormData();
            for( var i = 0; i < files.length; i++ ){
                // Проверяем выбранное количество файлов для загрузки, если больше 5 то отменяем загрузку и выводм сообщение
                if (this.uploadSettings.max_file_size && ((files[i].size / 1024) / 1024) >= this.uploadSettings.max_file_size ){
                    this.$vs.notify({
                        text: `Файл ${ files[i].name } превышает ${ this.uploadSettings.max_file_size } мегабайт!`,
                        color: 'warning'
                    })
                    continue;
                }
                // Проверяем загружали ли ранее файл с таким именем, если загружали выводим сообщение
                if(this.emc.files_data.find(item => item.formName === files[i].name)) {
                    this.$vs.notify({
                        text: `Файл ${ files[i].name } с таким именем уже загружен`,
                        color: 'warning'
                    })
                    continue;
                }

                // Заполняем formData перед загрузкой файлов
                formData.append('path', files[i]);
            }

            // Если formData не пустая то продолжаем отправку
            if(formData.has('path')) {
                try{

                    this.$vs.loading({
                        background: 'primary',
                        color: '#fff',
                        container: '.files_input_button',
                        scale: 0.45
                    })

                    // Загружаем файлы на сервер
                    const {data} = await this.$http.post('/common/upload/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })

                    // Пушим ответ с сервера в переменную, создаем нужные ключи для редактирования имени и описания файла
                    data.forEach(file => {
                        this.emc.files_data.push({
                            uid: file.uid,
                            formName: file.name,
                            name: '',
                            description: '',
                            response: file
                        })
                    })
                } catch(error) {
                    this.$vs.notify({ text: error, color:'danger' })
                } finally {
                    this.$vs.loading.close('.files_input_button > .con-vs-loading')
                }
            }
        },
        fileDelete(index) {
            // Удаляем файл из списка
            this.emc.files_data.splice(index, 1);
        },
        async openCreateModal (val) {
            try {
                this.$vs.loading()
                // Перед открытием формы создания УМК, запрашиваем настройки форм с сервера
                await this.fetchFormData()
                if(this.updatedData !== null){
                    this.updated = true;

                    this.createdData.disciplines.forEach(el=>{
                        if(el.uid === this.updatedData.discipline){
                            this.disciplineSelect = el;
                        }
                    })

                    this.emc = {
                        uid: this.updatedData.uid,
                        name: this.updatedData.name,
                        discipline: this.updatedData.discipline,
                        description: this.updatedData.description,
                        language: this.updatedData.language,
                        files_data: this.updatedData.files.map(el=> {

                            let res = el;
                            res['uploaded_uid'] = el.uid

                            return res

                        } )
                    }
                }
                if (val){
                    this.activePrompt = true
                }
            } catch(error) {
                this.$vs.notify({ text: error, color:'danger' })
            } finally {
                this.$vs.loading.close()
            }
        },
        multiselectAction (option) {
            // Выбираем дисциплину
            this.emc.discipline = option.uid
        },
        closePopup () {
            this.activePrompt = false
        },
        formSubmit () {
            // Проходим валидацию формы создания УМК
            this.$validator.validateAll().then(async result => {
                if (result && this.emc.files_data.length) {
                    try {
                        this.$vs.loading();
                        // Добавляем УМК в базу
                        if(this.updatedData !== null){

                            const res =  await this.updateEmc(this.emc)
                            await this.updateThisEmc(res.data)
                            this.$emit('closeView')
                            this.$vs.notify({ title: this.$t('succesful'), color:'success' })
                        } else {
                            await this.addEmc(this.emc)
                            this.$vs.notify({ title: this.$t('emc_created'), color:'success' })
                        }


                        // Очищамем форму
                        this.disciplineSelect = null
                        this.emc = {
                            name: '',
                            discipline: null,
                            description: '',
                            language: null,
                            files_data: []
                        }
                        this.activePrompt = false

                        this.$validator.reset();
                    } catch (error) {
                        const errArr = Object.values(error).join(' ');
                        this.$vs.notify({ text: errArr, color:'danger' })
                    } finally {
                        this.$vs.loading.close()
                    }
                } else {
                    if(!this.emc.files_data.length) this.$vs.notify({ text: this.$t('files_uploaded'), color:'danger' })
                }
            })
        }
    }
}
</script>

<style lang="scss">
.old_file_list{
    .name{
        color: #626262;
    }
}
.emc_popup{
    .files_input_button{
        max-width: 220px;
        position: relative;
        overflow: hidden;
        .con-vs-loading{
            position: absolute;
        }
    }
    .files_input{
        display: none;
    }
    .file_item{
        padding: 10px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        position: relative;
        .delete_button{
            position: absolute;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            top: -13px;
            right: -13px;
            z-index: 1;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .file_name{
            font-weight: bold;
            max-width: 390px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        &:not(:last-child){
            margin-bottom: 10px;
        }
    }
    .vs-popup{
        width: 800px!important;
    }
    .img-upload{
        width: 80px;
        height: 80px;
        margin: 0px;
        margin-right: 10px;
        .text-archive{
            font-size: 12px;
            span{
                &.block{
                    display: none!important;
                }
            }
        }
    }
    .con-input-upload{
        margin: 0px;
        width: 80px;
        height: 80px;
        .con-img-upload{
            margin-top: 0px;
        }
        .text-input{
            min-width: 70px;
            font-size: 12px;
        }
    }
}
</style>
